module.exports = __webpack_public_path__ + "img/accessoires.c8cb5e99.jpg";